import React, { useEffect, useState } from "react";
import { useTranslation } from "../../i18n/TranslationProvider";

import {
  Switch,
  Route,
  NavLink,
  useRouteMatch,
  useLocation,
} from "react-router-dom";

import { Row, Col, Nav } from "react-bootstrap/";
import Sallie from "../UIComponents/Sallie";
import ChangeNotification from "./ChangeNotification";
import SettingGoals from "./SettingGoals";

const AccountSetting = () => {
  let { path, url } = useRouteMatch();
  const location = useLocation();
  const { t } = useTranslation();
  let optionName = location.pathname.slice(16);
  const [sallieText, setSallieText] = useState("");
  const [isSuccess, setIsSuccess] = useState(undefined);

  useEffect(() => {
    if (isSuccess) {
      setSallieText(t("accountsetting.sallie.success"));
    } else if (isSuccess === false) {
      setSallieText(t("accountsetting.sallie.error"));
    } else if (optionName === "ChangeNotification" && isSuccess === undefined) {
      setSallieText(t("accountsetting.sallie.notification"));
    } else if (optionName === "setGoals" && isSuccess === undefined) {
      setSallieText(t("accountsetting.sallie.goals"));
    } else {
      setSallieText(t("accountsetting.sallie.default"));
    }
  }, [isSuccess, optionName, t]);

  return (
    <Row>
      <Col>
        <Sallie text={sallieText} />
        <Row className="d-flex justify-content-around">
          <Col md={3} className="accountSettingNav">
            <Nav
              variant="pills"
              className="flex-column"
              defaultActiveKey={`${url}/ChangeNotification`}
              defaultValue={`${url}/ChangeNotification`}
            >
              <Nav.Link
                eventKey={`${url}/ChangeNotification`}
                as={NavLink}
                to={`${url}/ChangeNotification`}
              >
                {t("accountsetting.nav.notification")}
              </Nav.Link>
              <Nav.Link
                eventKey={`${url}/setGoals`}
                as={NavLink}
                to={`${url}/setGoals`}
              >
                {t("accountsetting.nav.goals")}
              </Nav.Link>
            </Nav>
          </Col>
          <Col
            md={8}
            className="d-flex justify-content-center align-items-center"
          >
            <Switch>
              <Route path={`${path}/ChangeNotification`}>
                <ChangeNotification setIsSuccess={setIsSuccess} />
              </Route>
              <Route path={`${path}/setGoals`}>
                <SettingGoals setIsSuccess={setIsSuccess} />
              </Route>
            </Switch>
          </Col>
        </Row>
      </Col>
    </Row>
  );
};

export default AccountSetting;